module.exports = __webpack_public_path__ + "static/media/driving-license.a65242f7.jpeg";